import React, { useState, useEffect } from "react";
import { useModal } from "../../ConfirmationModal/ModalContext";
import useToast from "../../../API/GlobalHooks/useToast";
import { handleGet_data, handleSubmit_data, updateSubPrice } from "./sublimationPriceModel";
import "bootstrap/dist/css/bootstrap.min.css";

const SublimationPriceTable = () => {
  const showToast = useToast();
  const { showModal } = useModal();

  const [cloth, setCloth] = useState([]);
  const [printType, setPrintType] = useState([]);
  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  

  useEffect(() => {
    handleGet_data({ setListLoading, setCloth, setPrintType,setPrices });
  }, []);

  return (
    <div className="container my-2">      
      <h4 className="text-primary mb-2">Sublimation Price Master</h4>

      {listLoading ? (
        <div className="text-center my-5">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "2rem", height: "2rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted mt-2">Brewing your sublimation magic... please wait ✨</p>
        </div>
      ) : (
        <>
          <div className="table-responsive mb-3">
            <table
              className="table table-sm table-bordered text-center align-middle"
              style={{ fontSize: "0.75rem" }}
            >
              <thead className="table-light">
                <tr>
                  <th style={{ width: 140, padding: "4px" }}>Material / Type</th>
                  {printType.map(pt => (
                    <th key={pt.id} style={{ padding: "4px" }}>
                      {pt.print_type_name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {cloth.map(c => (
                  <tr key={c.id}>
                    <th style={{ padding: "4px" }}>{c.cloth_name}</th>
                    {printType.map(pt => (
                      <td key={pt.id} style={{ padding: "2px" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm text-center"
                          style={{
                            padding: "0.2rem",
                            fontSize: "0.7rem",
                            height: "28px",
                            minWidth: "50px"
                          }}
                          placeholder="0"
                          value={prices.find(
                            d => d.cloth_id === c.id && d.print_type_id === pt.id
                          )?.sub_price || ""}
                          onChange={e =>
                            updateSubPrice(c.id, pt.id, e.target.value,setPrices)                            
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-end">
            <button
              type='button'
              className="btn btn-sm btn-success"
              onClick={(e)=>{
                let data=prices;
                handleSubmit_data({data,setLoading,showToast})
              }}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Prices"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default SublimationPriceTable;
